export {
  SnapTaggedGoodsRowContainer as SnapTaggedGoodsRow,
  type SnapTaggedGoodsRowContainerProps as SnapTaggedGoodsRowProps,
} from './SnapTaggedGoodsRowContainer';
